module.exports = __webpack_public_path__ + "fonts/Montserrat-Light.409c7f79.ttf";